import { render, staticRenderFns } from "./h5_sub.vue?vue&type=template&id=98ad2930&scoped=true&"
import script from "./h5_sub.vue?vue&type=script&lang=js&"
export * from "./h5_sub.vue?vue&type=script&lang=js&"
import style0 from "./h5_sub.vue?vue&type=style&index=0&id=98ad2930&scoped=true&lang=scss&"
import style1 from "./h5_sub.vue?vue&type=style&index=1&id=98ad2930&lang=scss&"
import style2 from "./h5_sub.vue?vue&type=style&index=2&id=98ad2930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ad2930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98ad2930')) {
      api.createRecord('98ad2930', component.options)
    } else {
      api.reload('98ad2930', component.options)
    }
    module.hot.accept("./h5_sub.vue?vue&type=template&id=98ad2930&scoped=true&", function () {
      api.rerender('98ad2930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5_sub.vue"
export default component.exports